import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc5f8624")

_pushScopeId("data-v-fc5f8624")
const _hoisted_1 = { class: "optiondialog" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "item_area" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "option_image" }
const _hoisted_6 = { class: "aster" }
const _hoisted_7 = { class: "aster_message" }
const _hoisted_8 = { class: "commands" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "閉じる", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Thumbnail = _resolveComponent("Thumbnail")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_modal, {
      isShow: _ctx.isShowModalInner,
      "onUpdate:isShow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModalInner = $event)),
      title: "オプション絞り込み条件の例",
      isLeftTitle: true,
      isFitSize: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionImages, (option, qi) => {
            return (_openBlock(), _createBlock("div", {
              class: "q",
              key: qi
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("p", _hoisted_4, _toDisplayString(option.title), 1),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Thumbnail, {
                    item: option.thumbanil
                  }, null, 8, ["item"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("p", _hoisted_7, _toDisplayString(option.message), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("button", {
            class: "primary-button close_button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _hoisted_9
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow"])
  ]))
})